// extracted by mini-css-extract-plugin
export default {"discardButton":"DiscardChangesConfirm_discardButton__Mz+jL","keepEditing":"DiscardChangesConfirm_keepEditing__JOt1L"};